/**
 * Flag Routes
 *
 * Titles/descriptions/breadcrumbs are auto-resolved by the i18n router
 * guard from each route's `name` — see `src/plugins/i18n/routeI18n.ts`.
 */

export default [
  {
    path: 'flags',
    name: 'flags.overview',
    component: () => import('../../pages/flags/OverallView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'flags/:flagID',
    name: 'flags.detail',
    component: () => import('../../pages/flags/DetailView.vue'),
    meta: { requiresAuth: true }
  }
]
